const doGet = (url) => {
    return new Promise((resolve, reject) => {
        fetch(url, {
            credentials: 'include',
            headers: new Headers({
                'Accept': 'application/json'
            })
        }).then((response) => {
            return response.json()
        }).then((data) => {
            resolve(data);
        }).catch((e) => {
            reject(e);
        })
    })
};


const doPost = (url, payload) => {
    return new Promise((resolve, reject) => {
        fetch(url, {
            // credentials: 'include',
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {'content-type': 'application/json'}
        }).then(function (response) {
            return response.json();
        }).then(function (data) {
            resolve(data);
        }).catch((e) => {
            reject(e);
        });
    })
};

const doPut = (url, payload) => {
    return new Promise((resolve, reject) => {
        fetch(url, {
            credentials: 'include',
            method: 'PUT',
            body: JSON.stringify(payload),
            headers: {'content-type': 'application/json'}
        }).then(function (response) {
            return response.json();
        }).then(function (data) {
            resolve(data);
        }).catch((e) => {
            reject(e);
        });
    })
};

const doDelete = (url) => {
    return new Promise((resolve, reject) => {
        fetch(url, {
            credentials: 'include',
            method: 'DELETE',        
            headers: new Headers({
                'Accept': 'application/json'
            })
        }).then(function (response) {
            return response.json();
        }).then(function (data) {
            resolve(data);
        }).catch((e) => {
            reject(e);
        });
    })
};

export {
    doGet,
    doPost,
    doPut,
    doDelete
}

